import { SectionProps } from '@/components/features/Editor/utils';
import { Container, Flex, FlexProps, Text } from '@chakra-ui/react';
import { MotionBox } from '@sphere/ui';
import { rem } from 'polished';

interface Props extends Omit<SectionProps, 'title'>, Omit<FlexProps, 'title'> {
  activeItem?: 'text';
  isPreview?: boolean;
}

export const TextBlock = ({
  text,
  activeItem,
  isPreview,
  tokenIds: _tokenIds,
  ...props
}: Props) => {
  return (
    <Container bg="black" variant="breakout">
      <Flex
        align="center"
        justify="center"
        py={{ base: 'space.40', md: 'space.96', lg: rem(248) }}
        px={{ base: 'unset', md: 'space.64' }}
        color="white"
        {...props}
      >
        <MotionBox
          initial={{ opacity: isPreview ? 1 : 0 }}
          whileInView={{ opacity: 1 }}
          viewport={{ amount: 1, once: true }}
          transition={{ duration: 0.4, delay: 0.2 }}
        >
          <Text
            fontSize={{ base: 'xl', md: '2xl', lg: '3xl' }}
            bg={activeItem === 'text' ? 'arcticBlue' : 'unset'}
            color={activeItem === 'text' ? 'white' : 'inherit'}
            transition="all 120ms ease-in-out"
            lineHeight="sm"
            maxW={rem(1200)}
          >
            {text}
          </Text>
        </MotionBox>
      </Flex>
    </Container>
  );
};
